import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import "./ReviewForm.css";


function ReviewForm() {
  const navigate = useNavigate();
const [loadingUser, setLoadingUser] = useState(true);

  const [ratings, setRatings] = useState({
    availability: 0,
    punctuality: 0,
    conduct: 0,
    knowledge: 0,
    cleanliness: 0
  });
  const [comment, setComment] = useState('');
  const [user, setUser] = useState(null);
  
useEffect(() => {
  const userToken = localStorage.getItem("userToken");
  const storedUser = localStorage.getItem("userData");

  if (userToken && storedUser) {
    setUser(JSON.parse(storedUser));
    setLoadingUser(false);
  } else {
    navigate("/login?redirect=/review");
  }
}, []);
  
  const handleRatingChange = (question, value) => {
    setRatings(prev => ({
      ...prev,
      [question]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // اطمینان از این‌که کاربر به تمام سوالات امتیاز داده باشد
    if (Object.values(ratings).some(rating => rating === 0)) {
      alert("Please provide a rating for all questions.");
      return;
    }
    
    // آماده‌سازی داده‌های نظرسنجی به همراه اطلاعات کاربر
    const reviewData = {
      name: user?.Name,
      email: user?.Email,
      phone: user?.Phone,
      ratings,
      comment
    };

    try {
      const response = await fetch("http://localhost:3000/submit-review", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(reviewData)
      });
      const data = await response.json();
      alert(data.message);
      if (response.ok) {
        navigate("/customer-dashboard");
      }
    } catch (error) {
      console.error("Error submitting review:", error);
      alert("An error occurred while submitting your review.");
    }
  };

  const renderRatingButtons = (questionKey) => (
    [1,2,3,4,5].map(star => (
      <button
        type="button"
        key={`${questionKey}-${star}`}
        onClick={() => handleRatingChange(questionKey, star)}
        style={{
          color: ratings[questionKey] >= star ? 'gold' : 'gray',
          fontSize: '20px',
          background: 'none',
          border: 'none',
          cursor: 'pointer'
        }}
      >
        ★
      </button>
    ))
  );

  // محاسبه میانگین امتیازها (نمایش زنده در صفحه)
  const averageRating = (
    (ratings.availability + ratings.punctuality + ratings.conduct + ratings.knowledge + ratings.cleanliness) / 5
  ).toFixed(2);

if (loadingUser) return <p>Loading...</p>;

  return (
    <div className="review-form-container">
      <div className="header-bar">
        <img src={require('./assets/Logo.png')} alt="Logo" />
      </div>
      <div className="form-content">
        <p className="header-message">
          We sincerely appreciate you for using our service, and your feedback is invaluable in helping us improve our work.
        </p>
        <h1>Leave a Review</h1>
        <form onSubmit={handleSubmit}>
          <div className="review-question">
            <p>Was the service available for request at your preferred date and time?</p>
            <div>{renderRatingButtons('availability')}</div>
          </div>

          <div className="review-question">
            <p>Did the service provider arrive on time on the scheduled date?</p>
            <div>{renderRatingButtons('punctuality')}</div>
          </div>

          <div className="review-question">
            <p>Were you satisfied with the service provider's conduct?</p>
            <div>{renderRatingButtons('conduct')}</div>
          </div>

          <div className="review-question">
            <p>Did the service provider have sufficient knowledge and experience to perform the requested service?</p>
            <div>{renderRatingButtons('knowledge')}</div>
          </div>

          <div className="review-question">
            <p>Did the service provider pay adequate attention to the cleanliness of your environment and vehicle?</p>
            <div>{renderRatingButtons('cleanliness')}</div>
          </div>

          {/* نمایش میانگین امتیاز به صورت زنده */}
          <div className="average-rating">
            <p><strong>Average Rating:</strong> {averageRating}</p>
          </div>

          <div className="review-comment">
            <label>Additional Comments (optional):</label>
            <textarea 
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              maxLength={100}
              placeholder="Write your comments here (max 100 characters)..."
            />
          </div>
          <div className="button-group">
            <button type="submit" className="submit-button">Submit</button>
            <button type="button" className="back-button" onClick={() => navigate("/customer-dashboard")}>
              Back to Dashboard
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default ReviewForm;
